export const calculateExpiryTime = minutes => {
	const now = Date.now(); // Current timestamp in milliseconds
	const millisecondsInMinute = 60 * 1000; // 60 seconds * 1000 milliseconds
	const expiryTimeInMilliseconds = minutes * millisecondsInMinute;

	return now + expiryTimeInMilliseconds;
};

export const getTimeDifference = timestamp => {
	const now = Date.now();
	const diffInMilliseconds = timestamp - now;

	// Convert to minutes and seconds
	const minutes = Math.floor(diffInMilliseconds / (60 * 1000));
	const seconds = Math.floor((diffInMilliseconds % (60 * 1000)) / 1000);

	return {
		minutes,
		seconds,
		expired: diffInMilliseconds <= 0,
	};
};
